import React, { useState, useEffect } from 'react';
import {
    Container,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Paper,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Box,
} from '@mui/material';
import { supabase } from '../lib/supabase';

function TechniquePage() {
    const [techniques, setTechniques] = useState([]);
    const [open, setOpen] = useState(false);
    const [name, setName] = useState('');
    const [editingId, setEditingId] = useState(null);

    useEffect(() => {
        fetchTechniques();
    }, []);

    const fetchTechniques = async () => {
        const { data, error } = await supabase.from('techniques').select('*');
        if (error) {
            console.error('Error fetching techniques:', error);
        } else {
            setTechniques(data || []);
        }
    };

    const handleOpen = (technique = null) => {
        if (technique) {
            setName(technique.name);
            setEditingId(technique.id);
        } else {
            setName('');
            setEditingId(null);
        }
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setName('');
        setEditingId(null);
    };

    const handleSave = async () => {
        if (!name.trim()) return;

        if (editingId) {
            // Update existing technique
            const { error } = await supabase
                .from('techniques')
                .update({ name: name.trim() })
                .eq('id', editingId);
            if (error) {
                console.error('Error updating technique:', error);
            }
        } else {
            // Create new technique
            const { error } = await supabase
                .from('techniques')
                .insert([{ name: name.trim() }]);
            if (error) {
                console.error('Error creating technique:', error);
            }
        }

        handleClose();
        fetchTechniques();
    };

    const handleDelete = async (techniqueId) => {
        if (window.confirm('Are you sure you want to delete this technique? This action cannot be undone.')) {
            try {
                const { error } = await supabase
                    .from('techniques')
                    .delete()
                    .eq('id', techniqueId);

                if (error) {
                    console.error('Error deleting technique:', error);
                    alert('Error deleting technique. Please try again.');
                } else {
                    // Refresh the techniques list
                    fetchTechniques();
                }
            } catch (error) {
                console.error('Error deleting technique:', error);
                alert('Error deleting technique. Please try again.');
            }
        }
    };

    return (
        <Container sx={{ mt: 4 }}>
            <Typography variant="h4" gutterBottom>
                Techniques
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                <Button variant="contained" onClick={() => handleOpen()}>
                    Create New Technique
                </Button>
            </Box>

            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell align="right">Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {techniques.map((technique) => (
                            <TableRow key={technique.id}>
                                <TableCell>{technique.id}</TableCell>
                                <TableCell>{technique.name}</TableCell>
                                <TableCell>
                                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', justifyContent: 'flex-end' }}>
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            onClick={() => handleOpen(technique)}
                                        >
                                            Edit
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            color="error"
                                            onClick={() => handleDelete(technique.id)}
                                        >
                                            Delete
                                        </Button>
                                    </Box>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>{editingId ? 'Edit Technique' : 'Create New Technique'}</DialogTitle>
                <DialogContent>
                    <TextField
                        label="Technique Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        fullWidth
                        margin="dense"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button variant="contained" onClick={handleSave}>
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
}

export default TechniquePage;
